
export default function EcommercePartnersSection() {
  const partnerTypes = [
    {
      icon: "ri-taobao-line",
      title: "淘宝天猫合作",
      description: "深度合作淘宝天猫平台，提供店铺运营指导和爆款产品资源",
      features: ["店铺装修指导", "商品上架培训", "营销活动支持", "数据分析指导"],
      commission: "25-35%"
    },
    {
      icon: "ri-wechat-line", 
      title: "微信私域合作",
      description: "微信群、朋友圈营销，打造私域流量池，实现精准客户转化",
      features: ["素材包支持", "话术培训", "客户管理", "复购激励"],
      commission: "30-40%"
    },
    {
      icon: "ri-live-line",
      title: "直播带货合作",
      description: "抖音、快手等平台直播带货，专业团队提供全程指导支持",
      features: ["直播脚本", "产品培训", "流量扶持", "技术支持"],
      commission: "20-30%"
    },
    {
      icon: "ri-smartphone-line",
      title: "APP分销合作",
      description: "各类分销APP平台合作，简单易操作，适合兼职创业人群",
      features: ["零库存模式", "一键代发", "订单管理", "收益统计"],
      commission: "15-25%"
    }
  ];

  const advantages = [
    {
      icon: "ri-trophy-line",
      title: "爆款产品",
      description: "线上验证爆品，月销量10万+，转化率高达15%"
    },
    {
      icon: "ri-truck-line",
      title: "快速发货",
      description: "24小时内发货，全国95%地区次日达到"
    },
    {
      icon: "ri-customer-service-2-line",
      title: "专业售后",
      description: "7×24小时客服支持，退货率控制在2%以内"
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "高额佣金",
      description: "行业领先佣金比例，最高可达40%分成"
    },
    {
      icon: "ri-bar-chart-line",
      title: "数据支持",
      description: "实时销售数据，专业分析报告，助力精准营销"
    },
    {
      icon: "ri-group-line",
      title: "培训支持",
      description: "专业培训体系，从入门到精通全程指导"
    }
  ];

  return (
    <section id="ecommerce-partners-section" className="py-20 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-4xl font-bold text-[#663333] mb-4">
            电商合作伙伴
          </h2>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mb-6"></div>
          <p className="text-sm sm:text-xl text-gray-600 max-w-3xl mx-auto">
            聚焦线上渠道，多平台覆盖，专业运营支持，让您轻松开启电商创业之路
          </p>
        </div>

        {/* 合作类型 */}
        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {partnerTypes.map((type, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`${type.icon} text-xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-base sm:text-lg font-bold text-[#663333]">{type.title}</h3>
                    <span className="bg-[#cc9966] text-white px-3 py-1 rounded-full text-xs font-semibold">
                      佣金 {type.commission}
                    </span>
                  </div>
                  <p className="text-xs sm:text-sm text-gray-600 mb-4 leading-relaxed">{type.description}</p>
                  <div className="grid grid-cols-2 gap-2">
                    {type.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-2">
                        <i className="ri-check-line text-[#cc9966] text-xs flex-shrink-0"></i>
                        <span className="text-xs text-gray-600">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 核心优势 */}
        <div className="mb-16">
          <h3 className="text-xl sm:text-2xl font-bold text-[#663333] text-center mb-12">
            电商合作优势
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {advantages.map((advantage, index) => (
              <div key={index} className="bg-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="w-12 h-12 bg-gradient-to-br from-[#cc9966] to-[#b8865a] rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${advantage.icon} text-lg text-white`}></i>
                </div>
                <h4 className="text-sm sm:text-base font-bold text-[#663333] mb-2">{advantage.title}</h4>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 成功案例 */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-xl sm:text-2xl font-bold text-[#663333] text-center mb-8">
            成功案例
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="bg-gradient-to-br from-orange-100 to-amber-100 rounded-xl p-6 mb-4">
                <div className="text-2xl sm:text-3xl font-bold text-[#663333] mb-2">李女士</div>
                <div className="text-xs sm:text-sm text-gray-600 mb-2">淘宝店主</div>
                <div className="text-lg sm:text-xl font-bold text-[#cc9966]">月收入 8万+</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600">"合作3个月，店铺销量翻了5倍，产品质量好，客户回购率很高！"</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-orange-100 to-amber-100 rounded-xl p-6 mb-4">
                <div className="text-2xl sm:text-3xl font-bold text-[#663333] mb-2">王先生</div>
                <div className="text-xs sm:text-sm text-gray-600 mb-2">微信分销</div>
                <div className="text-lg sm:text-xl font-bold text-[#cc9966]">月收入 5万+</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600">"私域运营效果很好，客户粘性强，复购率达到60%以上！"</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-orange-100 to-amber-100 rounded-xl p-6 mb-4">
                <div className="text-2xl sm:text-3xl font-bold text-[#663333] mb-2">张女士</div>
                <div className="text-xs sm:text-sm text-gray-600 mb-2">直播带货</div>
                <div className="text-lg sm:text-xl font-bold text-[#cc9966]">月收入 12万+</div>
              </div>
              <p className="text-xs sm:text-sm text-gray-600">"直播间转化率高，每场直播都能卖出几千单，收益很可观！"</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
